import type { SellPriceBandSnapshot } from "@/lib/hooks/useSellPriceBand";
import type {
  PriceSuggestion,
  SellPriceBandPolicy,
} from "@/types/price-insight";

/** Maps `/api/pricing/suggest` payload to sell-flow band snapshot (single owner). */
export function mapPriceSuggestionToSellPriceBand(
  suggestion: PriceSuggestion,
): SellPriceBandSnapshot {
  const min = Math.round(suggestion.bandMin ?? suggestion.priceRange.minPrice);
  const max = Math.round(suggestion.bandMax ?? suggestion.priceRange.maxPrice);
  const enforcementEligible = Boolean(suggestion.enforcementEligible);
  const bandPolicy: SellPriceBandPolicy =
    suggestion.bandPolicy ?? (enforcementEligible ? "enforce" : "warn_allow");

  return {
    min,
    max,
    enforcementEligible,
    bandPolicy,
    sampleCount: suggestion.sampleCount ?? 0,
    cohortTier: suggestion.cohortTier,
    cohortMatchMode: suggestion.cohortMatchMode,
    exactCount: suggestion.exactCount,
    cohortCompCount: suggestion.cohortCompCount,
    segmentCompCount: suggestion.segmentCompCount,
    combinedProvenance: suggestion.combinedProvenance,
  };
}
